module.exports = __webpack_public_path__ + "img/fur-coloured.922f3cf5.svg";